// All steps which are visible in the dialog, the enum here defines the order!
export enum PAYROLL_REPORT_CREATION_PROCESS_STEP {
    SETTINGS,
    RESULT
}
export const PayrollReportCreationProcessStepLabels: { [K in PAYROLL_REPORT_CREATION_PROCESS_STEP]: string } = {
    [PAYROLL_REPORT_CREATION_PROCESS_STEP.SETTINGS]: $localize`Settings`,
    [PAYROLL_REPORT_CREATION_PROCESS_STEP.RESULT]: $localize`Completion`
};

export interface PayrollReportCreationProcessData {
    companyIds?: string[];
    asOfDate?: string;
}
